import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import intl from '@utils/intl';
import list from './actor/FAQList'
import { Modal } from 'antd-mobile';
import { OPERATOR_V } from '@src/constants';
import { homeStoreG } from '@viewsG/home/actor/store';
// import list from './actor/FAQList'
import faq1 from "@assets/img/faq/faq1.jpg"
import faq2 from "@assets/img/faq/faq2.png"
import faq3 from "@assets/img/faq/faq3.png"
import faq4 from "@assets/img/faq/faq4.png"
import faqs1 from "@assets/img/faq/faqs1.png"
import faqs2 from "@assets/img/faq/faqs2.png"
import faqs3 from "@assets/img/faq/faqs3.png"
import faqs4 from "@assets/img/faq/faqs4.png"
import faqs5 from "@assets/img/faq/faqs5.png"
import faqs6 from "@assets/img/faq/faqs6.png"
class FAQ extends ComponentExt<any, any> {
    private hueList = [
        {
            headerTitle: 'faq.title.1',
            question: 'faq.question.1',
            answerList: 'faq.answer.1',
            table: '1'
        },
        {
            question: 'faq.question.2',
            answerList: 'faq.answer.2',
        },
        {
            question: 'faq.question.3',
            answerList: 'faq.answer.3'
        },
        {
            question: 'faq.question.4',
            answerList: 'faq.answer.4',
        },
        {
            headerTitle: 'faq.title.2',
            question: 'faq.question.5',
            answerList: 'faq.answer.5',
            image: 'faq1'
        },
        {
            question: 'faq.question.6',
            answerList: 'faq.answer.6',
        },
        {
            question: 'faq.question.7',
            answerList: 'faq.answer.7'
        },
        {
            question: 'faq.question.8',
            answerList: 'faq.answer.8'
        },
        {
            question: 'faq.question.9',
            answerList: 'faq.answer.9',
        },
        {
            headerTitle: 'faq.title.3',
            question: 'faq.question.10',
            answerList: 'faq.answer.10',
            image: 'faq2'
        },
        {
            question: 'faq.question.11',
            answerList: [
                'faq.answer.11.1',
                'faq.answer.11.2',
                'faq.answer.11.3',
                'faq.answer.11.4',
            ]
        },
        {
            question: 'faq.question.12',
            answerList: 'faq.answer.12',
        },//
        {
            headerTitle: 'faq.title.4',
            question: 'faq.question.13',
            answerList: 'faq.answer.13',
            image: 'faq3'
        },
        {
            question: 'faq.question.14',
            answerList: [
                'faq.answer.14.1',
                'faq.answer.14.2',
                'faq.answer.14.3',
                'faq.answer.14.4',
                'faq.answer.14.5',
                'faq.answer.14.6',
                'faq.answer.14.7',
                'faq.answer.14.8',
            ],
            image: [{ index: 2, img: ['faqs1', 'faqs2'] }, { index: 6, img: ['faqs3', 'faqs4'] }, { index: 7, img: ['faqs5', 'faqs6'] }]
        },
        {
            question: 'faq.question.15',
            answerList: [
                'faq.answer.15.1',
                'faq.answer.15.2',
                'faq.answer.15.3',
            ],
            image: 'faq4'
        },
        {
            question: 'faq.question.16',
            answerList: 'faq.answer.16.1',
        },
        {
            headerTitle: 'faq.title.5',
            question: 'faq.question.17',
            answerList: 'faq.answer.17',
        },
        {
            question: 'faq.question.18',
            answerList: 'faq.answer.18',
        }
    ]
    constructor(props) {
        super(props)
        this.state = {
            prviewImg: false,
            imgUrl: ''
        }
    }
    render() {
        const faqImg = {
            faq1: faq1,
            faq2: faq2,
            faq3: faq3,
            faq4: faq4,
            faqs1: faqs1,
            faqs2: faqs2,
            faqs3: faqs3,
            faqs4: faqs4,
            faqs5: faqs5,
            faqs6: faqs6,
        }
        return (
            <section className={styles.faqWrapper}>
                {localStorage.getItem('chl') === 'tabletApp' ?
                    <div>
                        <h1 className={styles.title}>Lenovo Connect-Oak Tab LTE Connectivity FAQ</h1>
                        <Modal
                            visible={this.state.prviewImg}
                            transparent
                            maskClosable={false}
                            closable
                            onClose={() => this.setState({ prviewImg: false })}
                            style={{ overflow: 'auto' }}
                        >
                            <div style={{ paddingTop: '20px' }}>
                                <img style={{ width: '100%' }} src={this.state.imgUrl} />
                            </div>
                        </Modal>
                        {
                            this.hueList.map((item, index) =>
                                <div key={index} className={styles.FAQItem}>
                                    {item.headerTitle && <h2 className={styles.title}>{intl.formatMessage({ id: item.headerTitle })}</h2>}
                                    <div>
                                        <span className={styles.anwerItem} style={{ fontWeight: 500 }}>{intl.formatMessage({ id: item.question })}</span>
                                        {item.answerList instanceof Array ? item.answerList.map((item1, index1) =>
                                            <div key={index1}>
                                                <span className={styles.anwerItem} >{intl.formatMessage({ id: item1 })}</span>
                                                {item.image && item.image instanceof Array && item.image.map((item2) => {
                                                    if (item2.index === index1) {
                                                        return <div>
                                                            <img className={styles.faqsItem} src={faqImg[item2.img[0]]} onClick={() => this.setState({ prviewImg: true, imgUrl: faqImg[item2.img[0]] })} />
                                                            <img className={styles.faqsItem} src={faqImg[item2.img[1]]} onClick={() => this.setState({ prviewImg: true, imgUrl: faqImg[item2.img[1]] })} />
                                                        </div>
                                                    }
                                                }
                                                )}
                                            </div>
                                        ) : <span className={styles.anwerItem}>{intl.formatMessage({ id: item.answerList })}</span>}
                                    </div>
                                    {item.image && !(item.image instanceof Array) && <img className={styles.imgItem} src={faqImg[item.image]} onClick={() => this.setState({ prviewImg: true, imgUrl: faqImg[item.image] })} />}
                                    {item.table && <table className={styles.tableWrapper}>
                                        <tbody>
                                            <tr>
                                                <th>Country</th>
                                                <th>Technical Support</th>
                                                <th>Open Hours</th>
                                            </tr>
                                            <tr>
                                                <td>Italy</td>
                                                <td>(+39)02 303 10000</td>
                                                <td>09:00 - 18:00 Monday - Friday </td>
                                            </tr>
                                            <tr>
                                                <td>Spain</td>
                                                <td>+34 9179 11 799</td>
                                                <td>09:00 - 18:00 Monday - Friday  </td>
                                            </tr>
                                            <tr>
                                                <td>Portugal</td>
                                                <td>+351 211 227 833 </td>
                                                <td>09:00 - 18:00 Monday - Friday </td>
                                            </tr>
                                        </tbody>
                                    </table>}
                                </div>
                            )
                        }
                    </div> : <>{
                        list.map((item, index) => (
                            <div className={styles.FAQItem} key={index}>
                                <h1 className={styles.title}>{`${index + 1}.${intl.formatMessage({ id: item.questionMessageId })}`}</h1>
                                {
                                    item.imgs &&
                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        {
                                            item.imgs.map((imgItem, index1) => (
                                                <div className={styles.imgItem} key={index1}>
                                                    <img src={imgItem.url} />
                                                    <p>{intl.formatMessage({ id: imgItem.text })}</p>
                                                </div>
                                            ))
                                        }
                                    </div>
                                }
                                <p className={styles.content}>
                                    {
                                        item.answerMessageIds ? <>
                                            {
                                                item.answerMessageIds.map((item1, index1) => (
                                                    <span style={{ display: 'block', marginBottom: 5 }} key={index1}>{intl.formatMessage({ id: item1 })}</span>
                                                ))
                                            }
                                        </> : `${intl.formatMessage({ id: item.answerMessageId })}`
                                    }
                                </p>
                            </div>
                        ))
                    }</>
                }
            </section>
        )
    }
}

export default FAQ
